import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { GrFormPrevious } from "react-icons/gr";
import "../css/pagination.css";
import { MdDeleteOutline, MdOutlineNavigateNext } from "react-icons/md";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { useNavigate } from "react-router-dom";

const PER_PAGE = 25;

const Affiliates = () => {
  const navigate = useNavigate();
  const [allLinks, setAllLinks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [q, setQ] = useState("");

  function searchData() {
    // return activities;
    return allLinks.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.user?.toLowerCase().includes(q.toLowerCase())) {
        return user;
      }
    });
  }

  // API'S MakeDeletionApproved Starts
  const getallLinks = () => {
    const data = {
      user: userData?._id,
    };
    let config = {
      method: "post",
      url: Server2 + "/affiliates/links-get",
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setAllLinks(response.data.links);
        }
        else setAllLinks([]);
        setLoading(false);
        console.log(response.data.links, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Delete User");
      });
  };

  const handleDelete = (e) => {
    var data = JSON.stringify({
      id: e,
      from: userData._id,
    });
    var config = {
      method: "POST",
      url: Server2 + "/affiliates/delete-link",
      data: data,
      headers: { "Content-Type": "application/json" },
    };
    axios(config)
      .then((response) => {
        if(response.status === 200)
        getallLinks();
      })
      .catch((error) => {
        console.log("er", error);
      });
  };


  useEffect(() => {
    setLoading(true);
    getallLinks();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const convertionsCount = allLinks.reduce((acc, link) => {
    acc[link.clickName] = acc[link.clickName] ? acc[link.clickName] + 1 : 1;
    return acc;
  }, {});

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData = allLinks?.length === 0 ? null : searchData().slice(offset, offset + PER_PAGE).map((link, index) => (
    <tbody key={index} className="py-4">
      <tr>
        <td>
          <div className="ps-3 pe-2 py-1">
            {link?.clickName}
          </div>
        </td>
        <td>
          <div className="ps-3 pe-2 py-1">
            {link?.ip}
          </div>
        </td>
        <td>
          <div className="ps-3 pe-2 py-1">
            {link?.clickId}
          </div>
        </td>
        <td>
          <div className="ps-3 pe-2 py-1">
            {link?.disabled ? 'Disabled' : 'Active'}
            <br/>Hits {link?.hits}
          </div>
        </td>
        <td>
          <div className="ps-3 pe-2 py-1">
            {link?.createdAt}
          </div>
        </td>
        <td>
          <div className="d-flex justify-content-center py-1">
            <MdDeleteOutline
              style={{ zIndex: "10", padding: "4px" }}
              className="deleteAdmin"
              size={27}
              onClick={()=>{handleDelete(link?._id)}}
            />
          </div>
        </td>
      </tr>
    </tbody>
  ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
        <div className="d-flex gap-4 mb-2 mx-3">
          {Object.entries(convertionsCount).map(([name, count]) => (
            <div
              key={name}
              className="d-flex justify-content-between align-items-end rounded-4 px-4 py-2 gap-2"
              style={{
                backgroundColor: '#6148a1',
                color: 'white',
                height: 130,
                minWidth: 220,
              }}
            >
              <div width={'100%'}>
                <h6 className="text-white">{name}</h6>
                <h5 className="text-white">Users: {count}</h5>
              </div>
            </div>

            ))}
          </div>

          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0 pb-4">
                      <table className="table align-items-center mb-0">
                        {currentPageData !== null ? (
                          <>
                            <thead>
                              <tr>
                                <th className="text-uppercase">Name</th>
                                <th className="text-uppercase">By IP</th>
                                <th className="text-uppercase">Click ID</th>
                                <th className="text-uppercase">Status</th>
                                <th className="text-uppercase">Creation Date</th>
                                <th className="text-uppercase">Action</th>
                              </tr>
                            </thead>
                            {currentPageData}
                          </>
                        ) : (
                          <div className="d-flex justify-content-center w-100">
                            <p>No links yet</p>
                          </div>
                        )}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Affiliates;